import $ from 'jquery';
import 'select2';


document.addEventListener('DOMContentLoaded', function() {
    // Elements - Partie fiscale
    const citySelect = document.getElementById('fiscal-city');
    const baseInput = document.getElementById('fiscal-base');
    const calculateFiscalBtn = document.querySelector('#calculatorBtnFiscal');
    const fiscalResultElement = document.querySelector('.calculator__fiscal .calculator__result__number');

    // Elements - Partie bac individuel
    const volumeSelect = document.getElementById('bac-volume');
    const liftNumberInput = document.getElementById('lift-number');
    const calculateBacBtn = document.querySelector('#calculatorBtnBac');
    const bacResultElement = document.querySelector('.calculator__bac .calculator__result__number');

    // Element - Total
    const totalResultElement = document.querySelector('.calculator__total .calculator__result__number');

    // Prix au litre (constante)
    const PRICE_PER_LITER = 0.0565;

    // Variables pour stocker les résultats partiels
    let fiscalAmount = 0;
    let bacAmount = 0;

    // Initialiser Select2 avec les options en français
    $(citySelect).select2({
        placeholder: 'Sélectionner une commune...',

        language: {
            noResults: function() {
                return "Aucune commune trouvée";
            },
            searching: function() {
                return "Recherche en cours...";
            }
        },
        width: '100%'
    });

    // Initialiser Select2 avec les options en français
    $(volumeSelect).select2({
        placeholder: 'Rechercher une commune...',
        minimumResultsForSearch: Infinity,
        width: '100%'
    });

    // Load city data from JSON file
    fetch('/wp-content/themes/smectom-du-plantaurel/cityRate.json')
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return response.json();
        })
        .then(cities => {
            // Sort cities alphabetically
            cities.sort((a, b) => a.commune.localeCompare(b.commune));

            // Ajouter une option vide pour le placeholder
            const defaultOption = document.createElement('option');
            defaultOption.value = '';
            citySelect.appendChild(defaultOption);

            // Populate select options
            cities.forEach(city => {
                const option = document.createElement('option');
                option.value = city.taux;
                option.textContent = city.commune;
                option.dataset.epci = city.epci;
                citySelect.appendChild(option);
            });

            // Rafraîchir Select2 après avoir ajouté les options
            $(citySelect).trigger('change');
        })
        .catch(error => {
            console.error('Error loading city data:', error);
        });

    // Calculate button click handler - Partie fiscale
    calculateFiscalBtn.addEventListener('click', function() {
        // Get values
        const selectedRate = parseFloat(citySelect.value);
        const baseValue = parseFloat(baseInput.value);

        // Validate inputs
        const cityError = citySelect.parentElement.querySelector('.acf-error-message');
        const baseError = baseInput.parentElement.querySelector('.acf-error-message');

        let isValid = true;

        if (!selectedRate) {
            cityError.style.display = 'block';
            isValid = false;
        } else {
            cityError.style.display = 'none';
        }

        if (!baseValue || isNaN(baseValue) || baseValue <= 0) {
            baseError.style.display = 'block';
            isValid = false;
        } else {
            baseError.style.display = 'none';
        }

        // Calculate if valid
        if (isValid) {
            fiscalAmount = baseValue * selectedRate;
            fiscalResultElement.textContent = new Intl.NumberFormat('fr-FR', {
                style: 'currency',
                currency: 'EUR'
            }).format(fiscalAmount);
            fiscalResultElement.style.color = '#000000';

            // Mettre à jour le total
            updateTotal();
        }

    });

    // Calculate button click handler - Partie bac individuel
    calculateBacBtn.addEventListener('click', function() {
        // Get values
        const volumeValue = parseInt(volumeSelect.value);
        const liftNumberValue = parseInt(liftNumberInput.value);

        // Validate inputs
        const volumeError = volumeSelect.parentElement.querySelector('.acf-error-message');
        const liftNumberError = liftNumberInput.parentElement.querySelector('.acf-error-message');

        let isValid = true;

        if (!volumeValue) {
            volumeError.style.display = 'block';
            isValid = false;
        } else {
            volumeError.style.display = 'none';
        }

        if (!liftNumberValue || isNaN(liftNumberValue) || liftNumberValue <= 0) {
            liftNumberError.style.display = 'block';
            isValid = false;
        } else {
            liftNumberError.style.display = 'none';
        }

        // Calculate if valid
        if (isValid) {
            // Volume du bac X nombre de levées X prix au litre
            bacAmount = volumeValue * liftNumberValue * PRICE_PER_LITER;
            bacResultElement.textContent = new Intl.NumberFormat('fr-FR', {
                style: 'currency',
                currency: 'EUR'
            }).format(bacAmount);
            bacResultElement.style.color = '#000000';

            // Mettre à jour le total
            updateTotal();
        }

    });

    // Fonction pour mettre à jour le montant total
    function updateTotal() {
        const totalAmount = fiscalAmount + bacAmount;
        totalResultElement.textContent = new Intl.NumberFormat('fr-FR', {
            style: 'currency',
            currency: 'EUR'
        }).format(totalAmount);
        totalResultElement.style.color = '#000000';
    }

});